import { useState } from 'react'
import { Link } from 'react-router-dom'

export default function ForceHeader() {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="bg-force-bg/95 backdrop-blur-sm w-full sticky top-0 z-50 border-b border-force-border-light h-16">
      <div className="flex justify-between items-center h-16 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto">
        <Link to="/" className="flex items-center gap-3">
          <img alt="Force AI logo" className="w-12 h-12 object-contain rounded-lg" src="/assets/logo.png" />
          <span className="font-title-md text-title-md font-bold text-force-text tracking-wide">
            FORCE <span className="text-force-green-light">AI</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <a
            className="font-label-md text-label-md text-force-text-muted hover:text-force-text transition-colors"
            href="/#how-it-works"
          >
            Aspirants' Journey
          </a>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/login"
            className="font-label-md text-label-md text-force-text-muted hover:text-force-text transition-colors"
          >
            Log In
          </Link>
          <Link
            to="/login"
            className="bg-force-green text-force-text font-label-md text-label-md px-4 py-2 rounded-lg hover:bg-force-green-light transition-colors whitespace-nowrap"
          >
            Start Assessment
          </Link>
        </div>

        <button
          className="md:hidden text-force-text p-2"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="material-symbols-outlined">{menuOpen ? 'close' : 'menu'}</span>
        </button>
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-force-border-light bg-force-bg px-margin-mobile py-4 flex flex-col gap-4">
          <a
            className="font-label-md text-label-md text-force-text-muted hover:text-force-text transition-colors"
            href="/#how-it-works"
            onClick={() => setMenuOpen(false)}
          >
            Aspirants' Journey
          </a>
          <div className="flex flex-col gap-3 pt-2 border-t border-force-border-light">
            <Link
              to="/login"
              className="font-label-md text-label-md text-force-text-muted hover:text-force-text transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              Log In
            </Link>
            <Link
              to="/login"
              className="bg-force-green text-force-text font-label-md text-label-md px-4 py-2 rounded-lg hover:bg-force-green-light transition-colors text-center"
              onClick={() => setMenuOpen(false)}
            >
              Start Assessment
            </Link>
          </div>
        </nav>
      )}
    </header>
  )
}
